import { EditIcon } from '@chakra-ui/icons';
import { RemindersBell } from '@mybridge/icons';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  HStack,
  Stack,
  Text,
  useDisclosure,
} from '@mybridge/ui';
import { forwardRef, useContext, useEffect, useRef, useState } from 'react';
import { MyTestimonialsContext } from '../context';
import { RequestedNoDataIll } from '../ill/requested-no-data';
import { MyTestimonialsUserCard } from '../user-card';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const MyTestimonialsRequestedListing = forwardRef(
  ({ ...props }, ref) => {
    const {
      requestedTestimonials,
      requestedTestimonialsQuery,
      tab,
      deleteTestimonialMutation,
      deleteTestimonial,
      selected,
      setSelected,
      remindTestimonial,
      remindTestimonialMutation,
      reminded,
    } = useContext(MyTestimonialsContext);
    const { t } = useTranslator();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [testimonialToDelete, setTestimonialToDelete] = useState(null);
    const cancelRef = useRef();
    useEffect(() => {
      if (tab === 2) {
        requestedTestimonialsQuery?.refetch?.();
      }
    }, [tab]);
    return (
      <Stack spacing={4}>
        <Stack p={4} borderRadius={5} border="1px solid" borderColor="gray.200">
          {requestedTestimonials?.length ? (
            <>
              <Box>
                <Text display="inline">{t('profileTestimonials.yourRequests') || "Your requests"}</Text>
                <Text
                  py={0.5}
                  px={2}
                  // size="sm"
                  color="white"
                  ml={1}
                  bgColor="red.500"
                  borderRadius="full"
                  display="inline"
                >
                  {requestedTestimonials?.length}
                </Text>
              </Box>
              {requestedTestimonials?.map?.((testimonial, tIndex) => (
                <Stack
                  {...(tIndex < requestedTestimonials?.length - 1
                    ? { borderBottom: '1px solid', borderColor: 'gray.200' }
                    : {})}
                  p={4}
                  key={tIndex}
                  _hover={{
                    background: '#E2E2E2',
                  }}
                >
                  <MyTestimonialsUserCard
                    actions={
                      <HStack>
                        <Button
                          color="brandPrimary.500"
                          variant="ghost"
                          leftIcon={<EditIcon />}
                          onClick={(e) => {
                            setTestimonialToDelete(testimonial);
                            onOpen();
                          }}
                          isLoading={
                            selected?.id === testimonial?.id &&
                            deleteTestimonialMutation?.isLoading
                          }
                        >
                          {t('profileTestimonials.withdraw') || "Withdraw"}
                        </Button>
                        <Button
                          color="brandPrimary.500"
                          variant="ghost"
                          leftIcon={<RemindersBell width={'20'} height="20" />}
                          onClick={(e) => {
                            setSelected(testimonial);
                            remindTestimonial(testimonial);
                          }}
                          isLoading={
                            selected?.id === testimonial?.id &&
                            remindTestimonialMutation?.isLoading
                          }
                          isDisabled={reminded?.includes(testimonial?.id)}
                        >
                          {reminded?.includes(testimonial?.id) ? t('profileTestimonials.reminded') || 'Reminded' : t('profileTestimonials.remind') || 'Remind'}
                        </Button>
                      </HStack>
                    }
                    user={testimonial?.giver}
                    message={testimonial?.message}
                    createdAt={testimonial?.created_at}
                  />
                </Stack>
              ))}
            </>
          ) : (
            <Stack>
              <Text display="inline">{t('profileTestimonials.yourRequests') || "Your requests"}</Text>
              <HStack justifyContent="center">
                <Stack alignItems="center">
                  <RequestedNoDataIll />
                  <Text display="inline">{t('profileTestimonials.noCurrentRequests') || "You currently have no requests"}</Text>
                </Stack>
              </HStack>
            </Stack>
          )}
        </Stack>

        {/* Warning Dialog for Withdraw Action */}
        <AlertDialog
          motionPreset="slideInBottom"
          leastDestructiveRef={cancelRef}
          onClose={onClose}
          isOpen={isOpen}
          isCentered
        >
          <AlertDialogOverlay />
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {"Withdraw Testimonial Request"}
            </AlertDialogHeader>
            <AlertDialogBody>
              {"Are you sure you want to withdraw this testimonial request? This action cannot be undone."}
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button
                ref={cancelRef}
                onClick={onClose}
                borderRadius="50px"
                variant="secondary"
              >
                {t('buttons.cancel') || "Cancel"}
              </Button>
              <Button
                colorScheme="red"
                ml={3}
                borderRadius="50px"
                onClick={() => {
                  if (testimonialToDelete) {
                    setSelected(testimonialToDelete);
                    deleteTestimonial?.(testimonialToDelete);
                    setTestimonialToDelete(null);
                  }
                  onClose();
                }}
              >
                {t('profileTestimonials.withdraw') || "Withdraw"}
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </Stack>
    );
  }
);
